import axios from '@/axios';

const RESOURCE_NAME = '/admin/elastic-ai-chat-conversations';

export default {
    getConversations(data) {
        return axios.post(`${RESOURCE_NAME}/get-conversations`, data);
    },

    getConversationInfo(id) {
        return axios.get(`${RESOURCE_NAME}/get-conversation-info?id=${id}`);
    },
}
